import Vue from "vue"
import VueRouter from "vue-router"
import Lang from "../utils/lang.js"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import indexRoutes from "./modules/index"
import memberRoutes from "./modules/member"
import authRoutes from "./modules/auth"
import {
	getToken
} from "@/utils/auth"
import store from "../store"

const SITE_CLOSED_PATH = "/closed"
const MERCHANT_CLOSED_PATH = "/merchant-closed"

const isClosedStatus = status => status === 0 || status === "0"

function getClosedPagePath(siteInfo) {
	if (!siteInfo) return ""
	if (isClosedStatus(siteInfo.shop_status)) return SITE_CLOSED_PATH
	if (isClosedStatus(siteInfo.is_open)) return MERCHANT_CLOSED_PATH
	return ""
}

// 屏蔽跳转到本身时的报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	if (location && typeof location == "string" && location.indexOf("http") != -1) return window.location.open(location,
		"_self")

	return originalPush.call(this, location).catch(err => err)
}

const originalResolve = VueRouter.prototype.resolve
VueRouter.prototype.pushToTab = function pushToTab(location) {
	if (!location) return;
	if (location && typeof location == "string" && location.indexOf("http") != -1) return window.open(location, "_blank")

	const {
		href
	} = originalResolve.call(this, location)
	window.open(href, "_blank")
}

Vue.use(VueRouter)

/**
 * meta参数解析
 * module: 所属模块，目前用于寻找语言包
 * module: 菜单所属模块
 * menu: 所属菜单，用于判断三级菜单是否显示高亮，如菜单列表、添加菜单、编辑菜单都是'menu'，用户列表、添加用户、编辑用户都是'user'，如此类推
 */
const mainRouters = [
	indexRoutes,
	authRoutes,
	memberRoutes,
	{
		path: SITE_CLOSED_PATH,
		name: "closed",
		meta: {
			module: "index"
		},
		component: () => import("@/views/index/closed.vue")
	},
	{
		path: MERCHANT_CLOSED_PATH,
		name: "merchant_closed",
		meta: {
			module: "index"
		},
		component: () => import("@/views/index/merchant-closed.vue")
	},
	{
		path: "*",
		name: "error",
		meta: {
			module: "index"
		},
		component: () => import("@/views/index/error.vue")
	}
]

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes: mainRouters
})

let ifFirstLoad = true;
// 路由守卫，控制访问权限
router.beforeEach((to, from, next) => {
	if(ifFirstLoad){
		let res = store.dispatch("site/siteInfo");
		res.then(res1=>{
			ifFirstLoad = false;
			const closedPagePath = res1.code >= 0 ? getClosedPagePath(res1.data) : ""
			if (closedPagePath && to.path !== closedPagePath) {
				return next({ path: closedPagePath, replace: true })
			}
			if (!closedPagePath && to.path === MERCHANT_CLOSED_PATH) {
				return next({ path: "/index", replace: true })
			}
			if (to.meta.auth) {
				const token = getToken()
				if (!token) {
					return next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
				}
			}
			window.document.body.style.backgroundColor = to.meta.backgroundColor || ""
			NProgress.start()
			next()
		})
	}else{
		const closedPagePath = getClosedPagePath(store.getters.siteInfo)
		if (closedPagePath && to.path !== closedPagePath) {
			return next({ path: closedPagePath, replace: true })
		}
		if (!closedPagePath && to.path === MERCHANT_CLOSED_PATH) {
			return next({ path: "/index", replace: true })
		}
		if (to.meta.auth) {
			const token = getToken()
			if (!token) {
				return next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
			}
		}
		window.document.body.style.backgroundColor = to.meta.backgroundColor || ""
		NProgress.start()
		next()
	}
})

router.afterEach((to, from) => {
	const title = Lang.getLangField("title", to)
	const metaTitle = store.getters.siteInfo.site_name || ""
	window.document.title = `${title} - ${metaTitle}`
	setTimeout(() => {
		if (document.getElementsByClassName("el-main").length) {
			if (to.meta.mainCss) {
				for (let field in to.meta.mainCss) {
					document.getElementsByClassName("el-main")[0].style[field] = to.meta.mainCss[field]
				}
			} else {
				document.getElementsByClassName("el-main")[0].style = ""
			}
		}
	}, 100)
	NProgress.done()
})

export default router
